import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
import { types } from 'mobx-state-tree';
const getBillAsync = createAsync(body => {
  return async function getBill(options) {
    const resp = await api.FileApi.downloadFile(body, options);
    return resp;
  };
});
const downloadFileAsync = createAsync(body => {
  return async function downloadFile(options) {
    const resp = await api.FileApi.downloadFile(body, options);
    return resp;
  };
});
const getFilesArchiveAsync = createAsync(body => {
  return async function getFilesArchive(options) {
    const resp = await api.FileApi.downloadFileArchive(body, options);
    return resp;
  };
});
const FileCabinetStore = types.model('FileCabinetStore', {
  getBillAsync,
  getFilesArchiveAsync,
  downloadFileAsync
});
export const fileCabinet = types.optional(FileCabinetStore, {});